import React, { useState, useEffect } from "react";
import "./l002.css";
import crossicon from "../../assets/rr310/red-x.png";
import expandIcon from "../../assets/rr310/expand.png";
import upshortArrow from "../../assets/up-arrow.png";
import rightcurve from "../../assets/right-curve-arrow.png";
import cancel from "../../assets/cancel.png";
import "reactjs-popup/dist/index.css";
import { useDispatch } from "react-redux";
import { setModelColor } from "../../redux/actions/color-action";
import { setHotspotStatus } from "../../redux/actions/hotspot-action";
import { setHotspotClose } from "../../redux/actions/hotspot-close-action";
import { useSelector } from "react-redux";
import "react-html5video/dist/styles.css";
import Tooltip from "../../components/tooltip";
import HotspotModal from "../../components/hotspotModal";
import VideoModal from "../../components/hotspotVideoModal";
import FooterItems from "./components/footerItems";
// import star from "../../assets/star.png";
// import paint from "../../assets/paint.png";
import colorYellow from "../../assets/translucent_icons/yellow/color.png";
import colorWhite from "../../assets/translucent_icons/white/color.png";
import hotspotYellow from "../../assets/translucent_icons/yellow/hotspot.png";
import hotspotWhite from "../../assets/translucent_icons/white/hotspot.png";
import zoomin from "../../assets/pinch-to-zoom.png";
import rotate from "../../assets/drag-to-rotate.png";
import ExpandIcon from "../../components/expand";

const Web3D = ({ onConfigurator, setExpand, fullScreen }) => {
  const [open, setOpen] = useState(false);
  const [videoModel, setVideoModel] = useState(false);
  const [onColor, setColor] = useState(false);
  const [onHotspot, setHotspot] = useState(false);
  const [hotspotContent, setHotspotContent] = useState([]);
  const [hotspotBaseUrl, setHotspotBaseUrl] = useState();
  const [posterUrl, setPosterUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [longDesc, setLongDesc] = useState(false);
  const [modelToggle, setModelToggle] = useState(false);
  const [colorContent, setColorContent] = useState([]);
  const [tooltip, setTooltip] = useState(true);
  const [selectedColor, setSelectedColor] = useState(0);
  const dispatch = useDispatch();
  const onHotspotClick = useSelector((state) => state.hotspotClick.status);
  const meshdata = useSelector((state) => state.meshData.data);
  const hotspotdata = useSelector((state) => state.hotspotData.data);

  //

  // useEffect(() => {
  //   window
  //     .matchMedia("(orientation: portrait)")
  //     .addEventListener("change", function (e) {
  //       // if (e.matches) {
  //       //   setVideoModel(false);
  //       // }
  //     });
  // }, []);

  useEffect(() => {
    //This function call on hotspot click
    if (onHotspotClick) {
      setOpen(true);
      setHotspotBaseUrl(hotspotdata?.BaseUrl);
      setHotspotContent(
        hotspotdata?.HotspotContent?.filter((i) => i.ID === onHotspotClick)
      );
    }
    // if (onHotspotClick) {
    //   setOpen(true);
    //   axios.get(hotspotUrl).then((response) => {
    //     setHotspotBaseUrl(response.data.BaseUrl);
    //     setHotspotContent(
    //       response.data.HotspotContent.filter((i) => i.ID === onHotspotClick)
    //     );
    //   });
    // }
  }, [onHotspotClick]);

  useEffect(() => {
    meshdata?.map((item, key) => setColorContent(item.color));
    //
  }, [meshdata]);

  const onModelClose = () => {
    // document.getElementById("hotspot-icon").style.display = "unset";
    // document.getElementById("color-icon").style.display = "unset";
    setOpen(false);
    setLongDesc(false);
    dispatch(setHotspotClose({ id: onHotspotClick, status: modelToggle }));
    setModelToggle(!modelToggle);
  };

  const onVidelModel = (poster, video) => {
    setPosterUrl(poster);
    setVideoUrl(video);
    setVideoModel(!videoModel);
  };

  const onModelColor = () => {
    setColor(!onColor);
    setHotspot(false);
    //onModelClose();
    dispatch(setHotspotStatus(false));
  };

  const onModelHotspot = () => {
    setHotspot(!onHotspot);
    setColor(false);
    dispatch(setHotspotStatus(!onHotspot));
  };

  const onColorChange = (color, index) => {
    dispatch(setModelColor(color));
    setSelectedColor(index);
  };

  return (
    <>
      {tooltip && (
        <div
          className="tooltip-bg"
          onClick={() => {
            setTooltip(false);
            setExpand(true);
          }}
        ></div>
      )}

      <ExpandIcon fullScreen={fullScreen} setExpand={setExpand} />

      {open && (
        <HotspotModal
          onModelClose={() => onModelClose()}
          modalCloseIcon={crossicon}
          hotspotContent={hotspotContent}
          longDesc={longDesc}
          setLongDesc={() => setLongDesc(true)}
          showMoreIcon={expandIcon}
          hotspotBaseUrl={hotspotBaseUrl}
          onVidelModel={onVidelModel}
        />
      )}

      {videoModel && (
        <div
          className="tooltip-bg"
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 1,
            zIndex: 5,
            width: "100%",
            height: "100%",
          }}
        >
          <VideoModal
            open={videoModel}
            onClick={() => onVidelModel()}
            closeIcon={cancel}
            posterUrl={posterUrl}
            videoUrl={videoUrl}
          />
        </div>
      )}

      {tooltip && (
        <>
          <div className="hotspot-tooltip-u400config">
            <Tooltip
              upArrow={true}
              shortArrow={true}
              label={"Hotspot"}
              image={upshortArrow}
            />
          </div>
          <div className="colorswap-tooltip-u400config">
            <Tooltip
              curveRight={true}
              label={"Color swap"}
              image={rightcurve}
            />
          </div>
          <div className="config-tooltip-u400">
            <Tooltip
              upArrow={true}
              shortArrow={true}
              label={"Click to configure"}
              image={upshortArrow}
            />
          </div>
          <div className="pinch-to-zoom-tooltip">
            <Tooltip
              rotate={true}
              image={zoomin}
              label={"Pinch/Scroll for zoom in and zoom out."}
            />
          </div>

          <div className="drag-rotate-tooltip">
            <Tooltip zoomin={true} image={rotate} label={"Drag to rotate"} />
          </div>

          {/* <div className="expand">
            <Tooltip downArrow={true} image={downArrow} label={"Full screen"} />
          </div> */}
        </>
      )}
      {!open && (
        <>
          <div className="footer-u400">
            <FooterItems
              imageYellow={hotspotYellow}
              imageWhite={hotspotWhite}
              label={"Hotspot"}
              onClick={() => onModelHotspot()}
              onClicked={onHotspot}
              id="hotspot-icon"
            />

            <FooterItems
              imageYellow={colorYellow}
              imageWhite={colorWhite}
              label={"Color"}
              onClick={() => onModelColor()}
              onClicked={onColor}
              id="color-icon"
            />

            {onColor && (
              <div className="parallelogram-u400">
                {colorContent?.map((item, index) => (
                  <>
                    {item.colorCode ? (
                      <div className="parallelogram_u400_container">
                        <div
                          style={{ backgroundColor: "#" + item.colorCode }}
                          onClick={() => onColorChange(item.id, index)}
                        ></div>
                        <p
                          style={{
                            color: selectedColor === index && "#FFE100",
                          }}
                          className="rtr_footer_label boldFont"
                        >
                          {item.name}
                        </p>
                      </div>
                    ) : (
                      <img
                        src={item.path}
                        alt="color"
                        onClick={() => onColorChange(item.id, index)}
                      />
                    )}
                  </>
                ))}
              </div>
            )}
          </div>

          <div className="configurator-u400">
            {/* <div className="configurator-text">Configurator</div> */}
            <FooterItems
              buttonLabel={"Configure Your Bike"}
              onClick={() => {
                onConfigurator(1);
                onModelClose();
                dispatch(setHotspotStatus(false));
              }}
            />
          </div>
        </>
      )}
    </>
  );
};

export default Web3D;
